import React, { Component } from 'react';
import './editalumni.css';
import { Input, Modal, Button, Tabs, Row, Col, Spin, Empty, Icon, Alert, Collapse, Form, Select, DatePicker, Checkbox } from 'antd';
import moment from 'moment';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask'

import { stat } from 'fs';
const FormItem = Form.Item;
const Panel = Collapse.Panel;
const Option = Select.Option;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class SAFReg extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props,
        }
    }


    handleSAFSubmit = (j, e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let expdate = moment(values['saf_expire_date' + [j]]).format('YYYY-MM-DD')
                let effdate = moment(values['saf_effective_date' + [j]]).format('YYYY-MM-DD')
                this.props.actions.UpdateMembership(this.props.personGUID, values['registrationId' + [j]], effdate, expdate, "SAF")
            }
        })
    }


    componentDidMount = () => {
        this.props.actions.getSAFmembershiplevels()
    }


    renderSAFLevels = () => {
        if (this.props.saflevels) {
            let saflevels = this.props.saflevels
            return saflevels.map((k, index) => {
                return <Option value={k.id}>{(k.name).replace(/-/g, " ")}</Option>
            })
        }
    }

    renderSAFForm = (jIndex, saf_level_name, j) => {
        let status = ''
        if (moment(j.expireDate) > moment.now() && moment(j.effectiveDate) > moment.now()) {
            status = 'inactive'
        }
        if (moment(j.expireDate) < moment.now() && moment(j.effectiveDate) < moment.now()) {
            status = 'expiry'
        }
        if (moment(j.expireDate) > moment.now() && moment(j.effectiveDate) < moment.now()) {
            status = 'active'
        }

        const { getFieldDecorator } = this.props.form;
        return <Form layout="vertical" onSubmit={(e) => this.handleSAFSubmit(jIndex, e)}>
            <Row key={jIndex} type="flex" justify="space-between" align="bottom">
                <FormItem
                    label=""
                >
                    {getFieldDecorator('registrationId' + jIndex, {
                        initialValue: j.registrationId,
                        rules: [{ required: false, }],
                    })(
                        <input type='hidden' />
                    )}
                </FormItem>
                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <FormItem
                        label="SAF membership level:"
                    >
                        {getFieldDecorator('saf_membershiplevel' + jIndex, {
                            initialValue: saf_level_name ? saf_level_name : "",
                            rules: [{ required: false, message: 'Enter SAF Membership levels!' }],
                        })(
                            <Select disabled style={{ width: '100%' }} >
                                {this.renderSAFLevels()}
                            </Select>
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                    <FormItem
                        label="Effective Date:"
                    >
                        {getFieldDecorator('saf_effective_date' + jIndex, {
                            initialValue: j.effectiveDate ? moment(j.effectiveDate).format('MM/DD/YYYY') : "",
                            rules: [
                                { required: j.isActive, message: '' },
                                {
                                    pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                    message: `Please enter correct format MM/DD/YYYY Pattern`
                                }
                            ],
                        })(
                            // <DatePicker disabled={status == 'active' ? false : true} />
                            <InputMask
                                mask="99/99/9999"
                                disabled={status == 'active' ? false : true}
                                placeholder='MM/DD/YYYY'
                                alwaysShowMask
                                maskChar={null}
                                className="ant-input width-100"
                                render={(ref, props) => (
                                    <Input />
                                )}
                            />

                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                    <FormItem
                        label="Expire Date:"
                    >
                        {getFieldDecorator('saf_expire_date' + jIndex, {
                            initialValue: j.expireDate ? moment(j.expireDate).format('MM/DD/YYYY') : "",
                            rules: [
                                { required: j.isActive, message: '' },
                                {
                                    pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                    message: `Please enter correct format MM/DD/YYYY Pattern`
                                }
                            ],
                        })(
                            // <DatePicker disabled={status == 'active' ? false : true} />
                            <InputMask
                                mask="99/99/9999"
                                disabled={status == 'active' ? false : true}
                                placeholder='MM/DD/YYYY'
                                alwaysShowMask
                                maskChar={null}
                                className="ant-input width-100"
                                render={(ref, props) => (
                                    <Input />
                                )}
                            />

                        )}
                    </FormItem>
                </Col>
                <Col className="center" xs={24} sm={24} md={3} lg={3} xl={3}>
                    <FormItem>
                        {status == 'active' && <Alert message="Active" type="success" showIcon />}
                        {status == 'inactive' && <Alert message="Inactive" type="warning" showIcon />}
                        {status == 'expiry' && <Alert message="Expired" type="error" showIcon />}
                    </FormItem>
                </Col>
                <Col className="center" xs={24} sm={24} md={5} lg={5} xl={5}>
                    {status == 'active' && <FormItem>
                        <Button className="ant-btn-primary" htmlType="submit"> UPDATE MEMBERSHIP </Button>
                    </FormItem>}
                </Col>
            </Row>
        </Form>
    }

    renderSAFReg = () => {
        if (this.props.saf_reg_updating) {
            return <Spin indicator={LoadingIcon} className="loading-state" tip="Updating SAF Membership..." />
        }
        if (this.props.saf_reg_loading) {
            return <Spin indicator={LoadingIcon} className="loading-state" tip="Loading SAF Membership..." />
        }
        if (this.props.saf_reg) {
            if (this.props.saf_reg == "error") {
                return <Alert
                    message="Error"
                    description="Error Occurred while processing request"
                    type="error"
                    showIcon
                />
            }
            if (this.props.saf_reg.length == 0) {
                return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No SAF Membership" />
            }
            if (this.props.saflevels && this.props.saf_reg) {
                let saf_reg = this.props.saf_reg
                saf_reg.sort(function (a, b) {
                    return b.isActive - a.isActive;
                });
                return saf_reg.map((j, jIndex) => {
                    let saflevels = this.props.saflevels
                    let saf_level_name = ''
                    saflevels.map((k, index) => {
                        if (k.id == j.programId) saf_level_name = k.name
                    })
                    const { getFieldDecorator } = this.props.form;
                    return this.renderSAFForm(jIndex, saf_level_name, j)
                })
            }
        }
    }

    render() {
        return (
            <div className='maintain-membership'>
                {this.renderSAFReg()}
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        saflevels_loading: state.saflevelsreducer.loading,
        saflevels: state.saflevelsreducer.levels,
        saf_reg_loading: state.safregistrationreducer.loading,
        saf_reg: state.safregistrationreducer.reg,
        saf_reg_updating: state.safmembershipupdatereducer.loading
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}

const SAFRegistrations = Form.create()(SAFReg);

export default connect(mapStateToProps, mapDispatchToProps)(SAFRegistrations);


// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/SAFRegistration.js